export default __webpack_public_path__ + "static/media/bottle.c2723105.webp";